// Test/Local variables - used when REACT_APP_USE_TEST_VARIABLES=true
export const TestVariables = {
  COGNITO_USER_POOL_ID: 'us-east-2_ZQhVAPNOc',
  COGNITO_CLIENT_ID: '5c6qudl7dh9qlooqbreuh9agri',
  IDENTITY_POOL_ID: 'us-east-2:3a759dc9-8494-45b4-a18f-51c958811f4a',
  API_ENDPOINT: 'https://qxv4zfakqk.execute-api.us-east-2.amazonaws.com/prod',
  REGION: 'us-east-2',
  AGENT_GATEWAY_URL: 'https://chulas-agent-gateway-xbi4foc4qi.gateway.bedrock-agentcore.us-east-2.amazonaws.com/mcp',
  EMPLOYEE_API_ENDPOINT: 'https://ev1cuaxr59.execute-api.us-east-2.amazonaws.com/prod',
  EMPLOYEE_USER_POOL_ID: 'us-east-2_t7WDkeAnK',
  EMPLOYEE_CLIENT_ID: '6jmd6lpfl0mo2p50lsokto7ilq',
};
